import type { ApiError, PaginatedList } from "@entrilia/shared/api/types";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import { logError } from "@entrilia/shared/logging";
import { Divider, Stack } from "@mui/material";
import type { InvestorCommunicationInfo } from "../../../api/types/investorCommunicationsTypes";
import NoDataResult from "../../common/NoDataResult";
import NewsHeroCard from "../NewsHeroCard";

interface Props {
  newsPage: PaginatedList<InvestorCommunicationInfo> | undefined;
  fetchError: ApiError | undefined;
  isFetching: boolean;
  newsPagePath: string;
}

const NewsMobileList = ({ newsPage, fetchError, isFetching, newsPagePath }: Props) => {
  if (fetchError) {
    logError(fetchError, "[NewsMobileList] fetchError");
    return <DataLoadingFailed title="Failed to load news" />;
  }

  if (newsPage === undefined || isFetching) {
    return <InlineLoader />;
  }

  if (newsPage.items.length === 0) {
    return <NoDataResult text="No news found" />;
  }

  return (
    <Stack spacing={2.5} divider={<Divider />}>
      {newsPage.items.map((item) => (
        <NewsHeroCard key={item.id} item={item} to={`${newsPagePath}/${item.id}`} />
      ))}
    </Stack>
  );
};

export default NewsMobileList;
